<template>
 <div class="container">

<h1><font-awesome-icon icon="home" /> Home  - <a href="#">Event </a>

<div class="float-right" style="margin-top: -62px;">


  <b-button v-b-modal.modal-lg v-b-tooltip.hover title="Help" class="help"> <b-icon icon="question-square-fill" ></b-icon> Help</b-button>


  




</div>


</h1>

 

<div class="row">

 <div class="col-md-12" id="tabs">
<div class="tabs">
        <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">Active Event</a>
        <a v-on:click="activetab=2" v-bind:class="[ activetab === 2 ? 'active' : '' ]">All Events</a>
        <a v-on:click="activetab=3" v-bind:class="[ activetab === 3 ? 'active' : '' ]">Search User</a>
       
    
    </div>

    <div class="content">
        <div v-if="activetab === 1" class="tabcontent">
         <ActiveEvent @clicked='GetNext'/>
        </div>
        <div v-if="activetab === 2" class="tabcontent">
          <AllEvents />
        </div>

        <div v-if="activetab === 3" class="tabcontent">
          <SearchEvent />
        </div>

        <div v-if="activetab === 4" class="tabcontent">
          <Next @clicked='GetNext'/>
        </div>
      
    </div>




  </div>




  <!-- <div class="col-md-2 border-right">
    <Tap3/>
  </div> -->
  <!-- <div class="col-md-10">
    <div class="tab-content" id="v-pills-tabContent">
      <div class="tab-pane fade show active" id="v-pills-Current" role="tabpanel" aria-labelledby="v-pills-Current-tab"><ActiveEvent/></div>
      <div class="tab-pane fade" id="v-pills-History" role="tabpanel" aria-labelledby="v-pills-History-tab"><AllEvents /></div>
      <div class="tab-pane fade" id="v-pills-History2" role="tabpanel" aria-labelledby="v-pills-History-tab2"><SearchEvent /></div>
       <div class="tab-pane fade" id="v-pills-History3" role="tabpanel" aria-labelledby="v-pills-History-tab3"><Next /></div>

    </div>
  </div> -->





</div>




</div>

</template>

<script>
// import Tap3 from "../../components/Event/Tap3.vue";
import ActiveEvent from "../../components/Event/ActiveEvent.vue";
 import AllEvents from "../../components/Event/AllEvents.vue";
  import Next from "../../components/Event/Next.vue";
 import SearchEvent from "../../components/Event/SearchEvent.vue";
import studentData from '../../services/student/studentDataServices'

export default {
   components: {
     ActiveEvent,AllEvents,SearchEvent,Next,
//   
  },
  data () {
    return {
      info: '',
        el: '#tabs',
    activetab: 1,
  
    }
  },
   computed:{
          currenUser(){
            return  this.$store.state.auth.user
          },
        
        },

  mounted(){
        
      //this.currenUser.StudentID
            studentData.GetStudentAccountDetails(this.currenUser.StudentID).then(Response =>{
              // this.isLoading = false ;
               this.AccountDetails = Response.data
                // eslint-disable-next-line no-console
                  console.log(Response.data)
           }, error => {
              
                  // eslint-disable-next-line no-console
                  console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            })
  },methods:{
    GetNext(tabId){
      this.activetab = tabId
    }
  }
  



}


</script>

<style scoped>

.help {
    color: #fff;
    background-color: #ff8600;
    /* padding: 2px 16px; */
} 
h1{
    color:#285475;
    font-size:25px;
    border-bottom:1px #646464 dashed;
    padding:10px 0px;
}
h1 a{
    color:#ff8600;
}

.panal{
  background:#eee;
  border-radius:10px;
color:#333;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;


}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}

/* Style the tabs */
.tabs {
    overflow: hidden;
  margin-left: 20px;
    margin-bottom: -2px; 
}

.tabs ul {
    list-style-type: none;
    margin-left: 20px;
}

.tabs a{
    float: left;
    cursor: pointer;
    padding: 12px 24px;
    transition: background-color 0.2s;
    border: 1px solid #ccc;
    border-right: none;
    background-color: #285475;
    border-radius: 10px 10px 0 0;
    font-weight: bold;
     color: #fff;
}
.tabs a:last-child { 
    border-right: 1px solid #ccc;
}

/* Change background color of tabs on hover */
.tabs a:hover {
    background-color: #aaa;
    color: #fff;
}

/* Styling for active tab */
.tabs a.active {
   background-color: #fff;
    color: #285475;
    border-bottom: 2px solid #fff;
    cursor: default;
}

/* Style the tab content */
.tabcontent {
    padding: 30px;
    border: 1px solid #ccc;
    border-radius: 10px;
  box-shadow: 3px 3px 6px #e1e1e1;
  background: #fff;
  margin-bottom: 20px;
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}
</style>